var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheckInStar = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 12 12"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#00B8D9",
  stroke: "currentColor",
  d: "m7.136 1.794.175.17.242-.034 1.565-.221.273 1.556.042.24.216.115 1.396.74-.694 1.42-.108.22.108.22.694 1.42-1.396.74-.216.114-.042.241-.273 1.556-1.565-.221-.242-.034-.175.17L6 11.304l-1.136-1.098-.175-.17-.242.034-1.565.221-.273-1.556-.042-.24-.216-.115-1.396-.74.694-1.42.108-.22-.108-.22-.694-1.42 1.396-.74.216-.114.042-.241.273-1.556 1.565.221.242.034.175-.17L6 .696z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M8.14 3.707a.6.6 0 0 1 .154.837L6.088 7.752a.603.603 0 0 1-.889.115L3.795 6.664a.602.602 0 0 1 .783-.913l.722.623a.2.2 0 0 0 .16.046.2.2 0 0 0 .14-.085l1.7-2.473a.6.6 0 0 1 .84-.155"
})));
export default SvgCheckInStar;